export interface AccountViewModel {
  accountId: number;
  accountType: AccountType;
  addNewDate: Date;
  addNewEmployeeId: number;
  comment?: string;
  creditCardExpirationDate?: Date | string;
  creditCardLastFour?: string;
  creditCardOwnerName?: string;
  creditCardToken?: string;
  creditCardType?: string;
  updateDate?: Date | string;
  updateEmployeeId?: number;
  usage: string;
}

export interface CreditCardUpdateModel {
  accountType: AccountType;
  creditCardCvv: string;
  creditCardExpirationDate: string;
  creditCardOwnerName: string;
  creditCardNumber: string;
  comment: string;
}

export interface SavedCreditCard {
  readonly account: AccountViewModel;
  readonly name: string;
}

export enum AccountType {
  Customer = 1,
  RealEstateAgent = 9
}



// WEBPACK FOOTER //
// ./src/_models/Account.ts